(function() {
  'use strict';

  var STORAGE_KEY = 'nv_lang';
  var CLASS_IU = 'lang-iu';
  var CLASS_EN = 'lang-en';
  var PARAM_KEY = 'lang';

  function getStored() {
    try { return localStorage.getItem(STORAGE_KEY); } catch(e) { return null; }
  }

  function setStored(value) {
    try { localStorage.setItem(STORAGE_KEY, value); } catch(e) {}
  }

  function getUrlParam(key) {
    var params = new URLSearchParams(window.location.search);
    return params.get(key);
  }

  function removeUrlParam(key) {
    var url = new URL(window.location.href);
    url.searchParams.delete(key);
    window.history.replaceState({}, '', url.toString());
  }

  function applyLanguage(lang) {
    var body = document.body;
    if (lang === 'iu') {
      body.classList.add(CLASS_IU);
      body.classList.remove(CLASS_EN);
      document.documentElement.setAttribute('lang', 'iu');
    } else {
      body.classList.add(CLASS_EN);
      body.classList.remove(CLASS_IU);
      document.documentElement.removeAttribute('lang');
    }
  }

  function detectLanguage() {
    var urlLang = getUrlParam(PARAM_KEY);
    if (urlLang === 'iu' || urlLang === 'en') {
      setStored(urlLang);
      removeUrlParam(PARAM_KEY);
      return urlLang;
    }
    var stored = getStored();
    if (stored === 'iu' || stored === 'en') {
      return stored;
    }
    return 'en';
  }

  function toggleLanguage() {
    var current = document.body.classList.contains(CLASS_IU) ? 'iu' : 'en';
    var next = current === 'en' ? 'iu' : 'en';
    setStored(next);
    applyLanguage(next);
    window.dispatchEvent(new CustomEvent('nv:lang:changed', {
      detail: { lang: next }
    }));
  }

  function getCurrentLang() {
    return document.body.classList.contains(CLASS_IU) ? 'iu' : 'en';
  }

  var lang = detectLanguage();
  applyLanguage(lang);

  window.NVLang = {
    toggle: toggleLanguage,
    get: getCurrentLang,
    set: function(lang) {
      if (lang === 'iu' || lang === 'en') {
        setStored(lang);
        applyLanguage(lang);
        window.dispatchEvent(new CustomEvent('nv:lang:changed', {
          detail: { lang: lang }
        }));
      }
    }
  };

  document.addEventListener('click', function(e) {
    var toggle = e.target.closest('.nv-lang-toggle');
    if (toggle) {
      e.preventDefault();
      e.stopImmediatePropagation();
      toggleLanguage();
    }
  }, true);
})();